import React from 'react';
import {
  Switch,
  Route,
  BrowserRouter as Router,
} from 'react-router-dom';
import styled from 'styled-components';
import { 
  Email,
  Telegram,
  Instagram,
  GitHub,
  Public
} from '@material-ui/icons';
import './App.css';

import Home from './components/Home';
import About from './components/About';
import eCommerceChatbot from './components/Ecommerce-Chatbot';
import DialogflowChatbot from './components/Dialogflow';
import FAQ from './components/FAQ';
import Covid19 from './components/Covid19';

const Footer = styled.p`
    color: white;
    font-weight: lighter;
    text-align: center;
    letter-spacing: 0.1em;
    margin-top: 1em;
`;

class App extends React.Component {

  render() {
    return (
      <div className="main-container background-container" onLoad="">
        &nbsp;
        <Router>
          <Switch>
            <Route exact path="/" component={Home} />
            <Route exact path="/about" component={About} />
            <Route exact path="/online-store-chatbot" component={eCommerceChatbot} />
            <Route exact path="/dialogflow-chatbot" component={DialogflowChatbot} />
            <Route exact path="/covid19" component={Covid19} />
            <Route exact path="/faq" component={FAQ} />
          </Switch>
        </Router>
        <Footer>Made with <span style={{
          color: "#e25555"
        }}>&hearts;</span> by Diky Hadna
        <br />
        <br />
        <a href="mailto:dikyhd@gmail.com" target="_blank" rel="noopener noreferrer"><Email fontSize="small"style={{fill: "white"}}/></a> &nbsp;
        <a href="https://t.me/dkyhd" target="_blank" rel="noopener noreferrer"><Telegram fontSize="small"style={{fill: "white"}}/></a> &nbsp;
        <a href="https://instagram.com/nightbot.dev" target="_blank" rel="noopener noreferrer"><Instagram fontSize="small"style={{fill: "white"}}/></a> &nbsp;
        <a href="https://github.com/dkhd" target="_blank" rel="noopener noreferrer"><GitHub fontSize="small"style={{fill: "white"}}/></a> &nbsp;
        <a href="https://medium.com/@dkhd" target="_blank" rel="noopener noreferrer"><Public fontSize="small"style={{fill: "white"}}/></a> &nbsp;
        </Footer>
      </div>
    );
  }
}

export default App;
